import { LocalStorage } from './../../../utils/localstorage.utils';
import { Injectable } from '@angular/core';
import { Device, DeviceInfo } from '@core/capacitor-plugins/capacitor-plugins.class';
import { MANUFACTURER_TYPES } from '@shared/constants/manufacturer-types';
import { StorageKeys } from '@shared/constants/storage.const';
import { TerminalNames } from '@shared/constants/terminal-names.enum';
import { TargetDeviceEnum } from '@shared/constants';

@Injectable()
export class MyPosService {
  private _isMyPosPAXDevice = false;
  private _isMyPosXGDDevice = false;
  private _isMyPosSPRDDevice = false;
  private _isMyPosLEPHONEDevice = false;
  private _isMyPosQUALCOMMDevice = false;

  constructor(
    private localStorageService: LocalStorage
  ) {
    this.init();
  }

  private async init() {
    const { manufacturer, model } = await Device.getInfo();
    this._isMyPosXGDDevice = manufacturer === MANUFACTURER_TYPES.XGD;
    this._isMyPosPAXDevice = manufacturer === MANUFACTURER_TYPES.PAX;
    this._isMyPosSPRDDevice = manufacturer === MANUFACTURER_TYPES.SPRD;
    this._isMyPosLEPHONEDevice = manufacturer === MANUFACTURER_TYPES.LEPHONE;
    this._isMyPosQUALCOMMDevice = manufacturer === MANUFACTURER_TYPES.QUALCOMM && model?.toUpperCase() === 'F20';
  }

  get isMyPosDevice() {
    return (
      this.isMyPosN5Device ||
      this.isMyPosHubDevice ||
      this.isMyPosCarbonDevice ||
      this.isMyPosSlimDevice ||
      this.isMyPosProDevice ||
      this.isMyUltraDevice
    );
  }

  get isTargetDeviceMyPos(): boolean {
    const targetDevice: TargetDeviceEnum = this.localStorageService.get(StorageKeys.targetDevice) as TargetDeviceEnum;
    return targetDevice === TargetDeviceEnum.MYPOS;
  }

  get isMyPosN5Device() {
    return this._isMyPosXGDDevice;
  }

  get isMyPosHubDevice() {
    return this._isMyPosPAXDevice;
  }

  get isMyPosCarbonDevice() {
    return this._isMyPosSPRDDevice;
  }

  get isMyPosSlimDevice() {
    return this._isMyPosLEPHONEDevice;
  }

  get isMyPosProDevice() {
    return this._isMyPosQUALCOMMDevice;
  }

  get isMyUltraDevice() {
    const device: DeviceInfo = this.localStorageService.getObject(StorageKeys.fullDeviceInfo);
    const model: string = device.model;
    return Boolean(model) ? model === 'N96' && Boolean(this._isMyPosXGDDevice) : false;
  }

  get isMyPosScannerableDevice() {
    const isUltra: boolean = this.isMyUltraDevice;
    return this.isMyPosN5Device || this.isMyPosHubDevice || isUltra;
  }

  async getModelName() {
    const { model } = await Device.getInfo();
    return model;
  }

  get isMyPosTerminal() {
    const activeTerminal = this.localStorageService.getObject(StorageKeys.activeTerminal);
    return activeTerminal.name === TerminalNames.MINI;
  }

  get isMyPosTerminalAndPrinter() {
    const activeTerminal = this.localStorageService.getObject(StorageKeys.activeTerminal);
    return activeTerminal.name === TerminalNames.MINI && activeTerminal.printer;
  }

  get hasModernWebView() {
    return this.isMyPosN5Device;
  }

  get hasBroadcastScanner() {
    return this.isMyPosSlimDevice || this.isMyUltraDevice;
  }

  get isDisableEffect() {
    return this.isMyPosN5Device || this.isMyPosHubDevice || this.isMyPosCarbonDevice;
  }

  get isDisableModalAnimation() {
    return this.isMyPosN5Device || this.isMyPosCarbonDevice;
  }

  get hasMyPosPrinter() {
    return (
      this.isMyPosN5Device ||
      this.isMyPosHubDevice ||
      this.isMyPosCarbonDevice ||
      this.isMyPosTerminalAndPrinter ||
      this.isMyPosProDevice ||
      this.isMyUltraDevice
    );
  }
}
